import React from "react"
import ReactDOM from "react-dom"
import { useStaticQuery, graphql, Link } from "gatsby"
//importing winbox https://github.com/nextapps-de/winbox/issues/1
import WinBox from "winbox/src/js/winbox"
import "winbox/dist/css/winbox.min.css"

import Contact from "./Contact"
import PopupTerminalWindow from "../components/PopupTerminalWindow"

export default function ItemsList({
  filters = { sections: [], titleFilter: "" },
}) {
  const data = useStaticQuery(graphql`
    query {
      all: allMarkdownRemark(
        sort: { fields: [frontmatter___added, frontmatter___title], order: ASC }
      ) {
        edges {
          node {
            frontmatter {
              listName
              nameOfClass
              popupGithubLink
              popupImageAlt
              popupImageSrc
              techIcons
              title
              slug
              video
              added
            }
            html
            fileAbsolutePath
          }
        }
      }
      projects: allMarkdownRemark(
        filter: { fileAbsolutePath: { regex: "//projects/[^/]+$/" } }
        sort: {
          fields: [frontmatter___added, frontmatter___title]
          order: DESC
        }
      ) {
        edges {
          node {
            frontmatter {
              listName
              nameOfClass
              popupGithubLink
              popupImageAlt
              popupImageSrc
              techIcons
              title
              slug
              video
              added
              rank
            }
            html
            fileAbsolutePath
          }
        }
      }
      blogs: allMarkdownRemark(
        filter: { fileAbsolutePath: { regex: "//blogs/[^/]+$/" } }
        sort: {
          fields: [frontmatter___added, frontmatter___title]
          order: DESC
        }
      ) {
        edges {
          node {
            frontmatter {
              listName
              nameOfClass
              popupImageAlt
              popupImageSrc
              title
              slug
              video
              added
              metaTags
              metaLinks
              metaDescription
              rank
            }
            html
            fileAbsolutePath
          }
        }
      }
      info: allMarkdownRemark(
        filter: { fileAbsolutePath: { regex: "//info/[^/]+$/" } }
      ) {
        edges {
          node {
            frontmatter {
              listName
              nameOfClass
              popupGithubLink
              popupHRLink
              popupLCLink
              popupLILink
              popupImageAlt
              popupImageSrc
              techIcons
              title
              slug
              video
              added
            }
            html
            fileAbsolutePath
          }
        }
      }
      skills: allMarkdownRemark(
        filter: { fileAbsolutePath: { regex: "//skills/[^/]+$/" } }
      ) {
        edges {
          node {
            frontmatter {
              listName
              nameOfClass
              title
              slug
            }
            html
            fileAbsolutePath
          }
        }
      }
    }
  `)
  // popupLiveLink
  // Cloud
  const checkScreenWidth = () => {
    return window.screen.width > 1000 ? "75%" : "100%"
  }

  const checkScreenWidthMobile = () => {
    return window.screen.width < 1024 ? true : false
  }

  const createWinboxInstance = item => {
    const win = new WinBox({
      title: item.node.frontmatter.title,
      width: checkScreenWidth(),
      height: checkScreenWidth(),
      x: "center",
      y: "center",
      onfocus: function () {
        this.removeClass("wb-no-focus")
        this.addClass("wb-focus")
      },
      onblur: function () {
        this.removeClass("wb-focus")
        this.addClass("wb-no-focus")
      },
    })
    ReactDOM.render(
      React.createElement(PopupTerminalWindow, {
        title: item.node.frontmatter.title,
        popupImageSrc: item.node.frontmatter.popupImageSrc,
        popupImageAlt: item.node.frontmatter.popupImageAlt,
        video: item.node.frontmatter.video,
        popupGithubLink: item.node.frontmatter.popupGithubLink,
        popupHRLink: item.node.frontmatter.popupHRLink,
        popupLCLink: item.node.frontmatter.popupLCLink,
        popupLILink: item.node.frontmatter.popupLILink,
        popupLiveLink: item.node.frontmatter.popupLiveLink,
        metaTags: item.node.frontmatter.metaTags,
        metaLinks: item.node.frontmatter.metaLinks,
        metaDescription: item.node.frontmatter.metaDescription,
        rank: item.node.frontmatter.rank,
        techIcons: item.node.frontmatter.techIcons,
        Cloud: item.node.frontmatter.Cloud,
        html: item.node.html,
      }),
      win.body
    )
  }
  const shouldShowSection = section => {
    if (!filters.sections || filters.sections.length === 0) {
      return true
    }
    return filters.sections.includes(section)
  }

  const matchesTitle = item => {
    if (!filters.titleFilter) return true
    return (
      item.node.frontmatter.title
        .toLowerCase()
        .includes(filters.titleFilter.toLowerCase()) ||
      item.node.frontmatter.listName
        .toLowerCase()
        .includes(filters.titleFilter.toLowerCase())
    )
  }

  const applyFilters = (items, section) => {
    if (!items) return []
    let filteredItems = [...items]

    if (filters.tag) {
      const tagFields =
        section === "projects" ? ["techIcons", "Cloud"] : ["metaTags"]
      const searchTags = filters.tag.toLowerCase().split(" ")

      filteredItems = filteredItems.filter(item => {
        return searchTags.some(searchTag => {
          return tagFields.some(field => {
            const tags = item.node.frontmatter[field]
            return (
              Array.isArray(tags) &&
              tags.some(tag => tag.toLowerCase().includes(searchTag))
            )
          })
        })
      })
    }

    if (filters.search && filters.search.length > 0) {
      const searchTerms = Array.isArray(filters.search) ? filters.search : [filters.search]
      filteredItems = filteredItems.filter(item => {
        const title = item.node.frontmatter.title.toLowerCase()
        const listName = item.node.frontmatter.listName.toLowerCase()
        
        // Item matches if ANY of the search terms are found in either title or listName
        return searchTerms.some(term => {
          const searchStr = term.toLowerCase()
          return title.includes(searchStr) || listName.includes(searchStr)
        })
      })
    }

    if (filters.sort) {
      const [field, order] = filters.sort.startsWith("-")
        ? [filters.sort.slice(1), "desc"]
        : [filters.sort, "asc"]

      filteredItems.sort((a, b) => {
        let comparison = 0
        if (field === "time") {
          comparison =
            new Date(a.node.frontmatter.added) -
            new Date(b.node.frontmatter.added)
        } else if (field === "rank") {
          comparison =
            (a.node.frontmatter.rank || 0) - (b.node.frontmatter.rank || 0)
        } else if (field === "name") {
          comparison = a.node.frontmatter.listName.localeCompare(
            b.node.frontmatter.listName
          )
        }
        return order === "desc" ? -comparison : comparison
      })
    }

    if (filters.limit) {
      filteredItems = filteredItems.slice(0, filters.limit)
    }

    return filteredItems
  }

  const info = data.info.edges.filter(matchesTitle).map(item => (
    <li key={item.node.frontmatter.title} className="infoItem">
      <button
        className="popupWindowLinkButton"
        style={{ cursor: "pointer" }}
        onClick={() => createWinboxInstance(item)}
      >
        {item.node.frontmatter.listName}
      </button>
    </li>
  ))

  const skills = data.skills.edges.filter(matchesTitle).map(item => {
    return (
      <li key={item.node.frontmatter.title} className="infoItem">
        <button
          className="popupWindowLinkButton"
          style={{ cursor: "pointer" }}
          onClick={() => createWinboxInstance(item)}
        >
          {item.node.frontmatter.listName}
        </button>
      </li>
    )
  })
  const infoMobile = data.info.edges.map(item => (
    <li key={item.node.frontmatter.title} className="infoItem">
      <Link
        className="popupWindowLinkButton"
        style={{ cursor: "pointer" }}
        to={item.node.frontmatter.slug}
      >
        {item.node.frontmatter.listName}
      </Link>
    </li>
  ))
  const skillsMobile = data.skills.edges.map(item => {
    return (
      <li key={item.node.frontmatter.title} className="infoItem">
        <Link
          className="popupWindowLinkButton"
          style={{ cursor: "pointer" }}
          to={item.node.frontmatter.slug}
        >
          {item.node.frontmatter.listName}
        </Link>
      </li>
    )
  })

  const projects = applyFilters(data.projects.edges, "projects").map(item => (
    <li
      key={item.node.frontmatter.title}
      className={item.node.frontmatter.nameOfClass}
      style={{ display: "flex", alignItems: "center", width: "100%" }}
    >
      <button
        className="popupWindowLinkButton"
        style={{ cursor: "pointer", width: "30%" }}
        onClick={() => createWinboxInstance(item)}
      >
        {item.node.frontmatter.listName}
      </button>
      <span
        style={{
          fontSize: "x-small",
          paddingLeft: "0.5rem",
          textJustify: "right",
          width: "70%",
        }}
      >
        {`lrwxr-xr-x 1 utsav admin ${item.node.frontmatter.added} ${item.node.frontmatter.slug}  `}
        <a href={item.node.frontmatter.popupGithubLink}>
          {item.node.frontmatter.popupGithubLink}
        </a>
      </span>
    </li>
  ))

  const projectsMobile = data.projects.edges.map(item => (
    <li
      key={item.node.frontmatter.title}
      className={item.node.frontmatter.nameOfClass}
    >
      <Link
        className="popupWindowLinkButton"
        style={{ cursor: "pointer" }}
        to={item.node.frontmatter.slug}
      >
        {item.node.frontmatter.listName}
      </Link>
    </li>
  ))

  const blogs = applyFilters(data.blogs.edges, "blogs").map(item => (
    <li
      key={item.node.frontmatter.title}
      className={item.node.frontmatter.nameOfClass}
      style={{ display: "flex", alignItems: "center", width: "100%" }}
    >
      <button
        className="popupWindowLinkButton"
        style={{ cursor: "pointer", width: "30%" }}
        onClick={() => createWinboxInstance(item)}
      >
        {item.node.frontmatter.listName}
      </button>
      <span
        style={{
          fontSize: "x-small",
          paddingLeft: "0.5rem",
          textJustify: "right",
          width: "70%",
        }}
      >
        {`lrwxr-xr-x 1 ${item.node.frontmatter.added} ${item.node.frontmatter.slug}  `}
      </span>
    </li>
  ))

  const blogsMobile = data.blogs.edges.map(item => (
    <li
      key={item.node.frontmatter.title}
      className={item.node.frontmatter.nameOfClass}
    >
      <Link
        className="popupWindowLinkButton"
        style={{ cursor: "pointer" }}
        to={item.node.frontmatter.slug}
      >
        {item.node.frontmatter.listName}
      </Link>
    </li>
  ))

  const contactItem = (
    <li className="infoItem">
      <button
        className="popupWindowLinkButton"
        style={{ cursor: "pointer" }}
        onClick={() => {
          const win = new WinBox({
            title: "Contact me",
            width: checkScreenWidth(),
            height: checkScreenWidth(),
            x: "center",
            y: "center",
            onfocus: function () {
              this.removeClass("wb-no-focus")
              this.addClass("wb-focus")
            },
            onblur: function () {
              this.removeClass("wb-focus")
              this.addClass("wb-no-focus")
            },
          })

          ReactDOM.render(
            React.createElement(Contact, {
              close: () => win.close(),
            }),
            win.body
          )
        }}
      >
        <span role="img" aria-label="e-mail">
          📧
        </span>{" "}
        /Contact
      </button>
    </li>
  )

  const mappedItems = () => {
    return (
      <>
        {shouldShowSection("info") && (
          <>
            <li>→ Info:</li>
            {info} {skills} {contactItem}
          </>
        )}
        {shouldShowSection("projects") && (
          <>
            <li>→ Projects:</li>
            {projects}
          </>
        )}
        {shouldShowSection("blogs") && (
          <>
            <li>→ Blogs:</li>
            {blogs}
          </>
        )}
      </>
    )
  }

  const mappedItemsMobile = () => {
    return (
      <>
        <li>→ Info:</li>
        {infoMobile} {skillsMobile}{" "}
        <li className="infoItem">
          <Link
            className="popupWindowLinkButton"
            style={{ cursor: "pointer" }}
            to="/contact"
          >
            <span role="img" aria-label="e-mail">
              📧
            </span>{" "}
            /Contact
          </Link>
        </li>{" "}
        <li>→ Projects:</li>
        {projectsMobile}
        <li>→ Blogs:</li>
        {blogsMobile}
        {/* <li className="miniProject">→ Mini-Projects:</li> */}
      </>
    )
  }

  return (
    <ul className="mappedItemsList">
      {checkScreenWidthMobile() ? mappedItemsMobile() : mappedItems()}
    </ul>
  )
}
